import React from 'react';

const cx = (...c) => c.filter(Boolean).join(' ');

const TINT = {
  lilac: 'bg-sky',
  peach: 'bg-cream',
  blush: 'bg-cream',
  sage: 'bg-sky',
  cream: 'bg-cream',
  white: 'bg-white border border-line',
  ink: 'bg-ink text-white/80',
};

/** A big rounded tinted block — the signature "soft colour-pop" container. */
const Panel = ({
  children, tint = 'lilac', className, as: Tag = 'div',
}) => (
  <Tag className={cx('rounded-4xl p-7 sm:p-10 md:p-14', TINT[tint], className)}>{children}</Tag>
);

export default Panel;
